import { map, Observable, Subject, takeUntil } from 'rxjs';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { Component, inject, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngxs/store';
import { OrganizationActions, OrganizationState, Organization } from '@app/_store';
import { Navigate } from '@ngxs/router-plugin';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgIf, RouterOutlet, AsyncPipe],
})
export class OrganizationComponent implements OnDestroy {
  componentDestroyed$: Subject<boolean> = new Subject<boolean>();
  currentOrganization$: Observable<Organization> = inject(Store).select(OrganizationState.current);

  constructor(
    private store: Store,
    private route: ActivatedRoute
  ) {
    this.route.paramMap.subscribe(params => {
      const organizationId = params.get('id');
      this.store.dispatch(new OrganizationActions.View(organizationId));
    });

    this.currentOrganization$
      .pipe(
        takeUntil(this.componentDestroyed$),
        map(org => {
          if (org && org.removeDate) {
            this.store.dispatch(new Navigate(['organization', org.id, 'to-be-removed']));
          }
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.store.dispatch(new OrganizationActions.ClearCurrent());
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
